import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

// Loads Google Analytics (GA4) when a Measurement ID is configured in admin,
// then reports a page view on every client side route change.
export function Analytics() {
  const loc = useLocation();
  const gaId = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => {
      const id = (r.data?.google_analytics_id || "").trim();
      if (!id || gaId.current) return;
      gaId.current = id;
      const tag = document.createElement("script");
      tag.async = true;
      tag.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      document.head.appendChild(tag);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", id, { send_page_view: false });
      setReady(true);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (!ready || !window.gtag || !gaId.current) return;
    window.gtag("event", "page_view", {
      page_path: loc.pathname + loc.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [ready, loc.pathname, loc.search]);

  return null;
}
